import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { Table, ZeroState, NotifPref } from 'ecs-react-components/dist/index.es';
import { messages } from './Appointments.i18n';
import { loadAppointments, setSortField } from '../../redux/modules/appointment/appointment-middleware';
import AppointmentFilters from './AppointmentFilters';
import { auditRequest } from '../../redux/modules/audit/audit-middleware';
import { columns } from './AppointmentGridConfig';
import Header from '../../components/Header/Header';
import LoadingIndicatorContainer from '../LoadingIndicatorContainer';
import { callWithLoadingIndicator } from '../../redux/modules/loading-indicator/loading-indicator-middleware';

const APPOINTMENT_VIEW_AUDIT_TYPE = 'appointmentviewauditevent';

class Appointments extends Component {
  UNSAFE_componentWillMount() {
    if (this.props.patient.patientId) {
      this.props.dispatch(auditRequest(APPOINTMENT_VIEW_AUDIT_TYPE, this.props.patient.patientId));
      this.props.dispatch(callWithLoadingIndicator(
        'Appointments', () => this.props.dispatch(loadAppointments(this.props.patient.patientId))));
    }
  }

  render() {
    const gridOptions = {
      dataSortField: this.props.sortOption.field,
      sortDirection: this.props.sortOption.direction.toUpperCase(),
      onSortChange: (field, direction) => {
        this.props.dispatch(setSortField(field, direction));
      },
    };
    const config = {
      columns: columns(
        this.props.dispatch,
        this.props.timeZone,
        messages,
        this.props.language
      ),
    };

    const renderedTable = () => (
      <>
        <Table
          columns={ config.columns }
          data={ this.props.appointments.filter((a) => !a.isFiltered) }
          { ...gridOptions }
        />
        <p className="small" data-qa-item="notifPref">
          <FormattedMessage
            { ...messages.statements.preference }
            values={{ patientNotifPref:
              <NotifPref
                fieldName={ <FormattedMessage { ...messages.notifPreference.FieldName } /> }
                patientNotifPreference={ this.props.patientNotifyPreference }
              />,
            }}
          />
        </p>
        <p className="small" data-qa-item="timeZoneWarning">
          <FormattedMessage
            { ...messages.statements.timezone }
            values={{ facilityTimeZone: this.props.timeZone }}
          />
        </p>
      </>
    );

    return (
      <div className="row" id="appointments-content">
        <div className="col">
          <Header headerClassName="mb-3" headerTitle={ <FormattedMessage { ...messages.page.header } /> } />
          <LoadingIndicatorContainer loadingKey="Appointments">
          {
            this.props.unfilteredCount ?
              <>
              <AppointmentFilters
                filteredRows={ this.props.appointments ?
                  this.props.appointments.filter((x) => !x.isFiltered).length : 0 }
                allRows={ this.props.unfilteredCount || 0 }
              />
              {
                this.props.appointments &&
                  this.props.appointments.filter((a) => !a.isFiltered).length > 0 ?
                  renderedTable() :
                  (
                    <ZeroState
                      zeroStateMessage={ <FormattedMessage { ...messages.statements.noAppointments } /> }
                      stateIconCss="fa-regular fa-calendar"
                    />
                  )
              }
              </>
              :
              (
                <ZeroState
                  zeroStateMessage={ <FormattedMessage { ...messages.statements.noAppointments } /> }
                  stateIconCss="fa-regular fa-calendar"
                />
              )
          }
          </LoadingIndicatorContainer>
        </div>
      </div>
    );
  }
}

Appointments.propTypes = {
  dispatch: PropTypes.func.isRequired,
  appointments: PropTypes.array,
  sortOption: PropTypes.object,
  patient: PropTypes.object,
  timeZone: PropTypes.string,
  language: PropTypes.string,
  unfilteredCount: PropTypes.number,
  patientNotifyPreference: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
};

const mapStateToProps = (state) => ({
  appointments: state.appointment.appointments,
  sortOption: state.appointment.sortOption,
  patient: state.profile.patient,
  timeZone: state.facility.timeZoneAbbreviation,
  language: state.language.languageCode,
  unfilteredCount: state.appointment.unfilteredCount,
  patientNotifyPreference: state.appointment.patientNotifyPreference,
});

export default connect(mapStateToProps)(Appointments);